import React from 'react';

type AddNestedBetweenLineProps = {
  id?: string;
  parentId: string;
  beforeIndex?: number;
  onAdd: (parentId: string, beforeIndex?: number) => void;
}

export const AddNestedBetweenLine = ({ id, parentId, beforeIndex, onAdd }: AddNestedBetweenLineProps) => {
  const baseId = id || 'add-nested-between-line';

  return (
    <div id={baseId} data-testid={baseId} className="tw-relative tw-flex tw-items-center tw-group tw-h-5 tw-cursor-pointer tw-my-2 tw-w-full">
      <div id={`${baseId}-line-left`} className="tw-flex-1 tw-h-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
      <div id={`${baseId}-button-wrapper`} className="tw-px-2">
        <button
          id={`${baseId}-add-btn`}
          data-testid={`${baseId}-add-btn`}
          className="tw-w-5 tw-h-5 tw-rounded-full tw-bg-transparent tw-text-transparent group-hover:tw-bg-[#1F7AE4] group-hover:tw-text-white tw-flex tw-items-center tw-justify-center tw-shadow-none group-hover:tw-shadow-md tw-transition-all tw-duration-200"
          onClick={() => onAdd(parentId, beforeIndex)}
        >
          <span id={`${baseId}-icon`} className="tw-text-base">+</span>
        </button>
      </div>
      <div id={`${baseId}-line-right`} className="tw-flex-1 tw-h-px tw-bg-transparent group-hover:tw-bg-[#1F7AE4] tw-transition-colors tw-duration-200"></div>
    </div>
  );
};